export type TSubjectType = 'PATIENT' | 'HR_CONTACT'

export enum EChannelStatusTag {
  FREE = 'FREE',
  ASSIGNED_TO_SUBJECT = 'ASSIGNED_TO_SUBJECT',
  USED_BY_PATIENT = 'USED_BY_PATIENT',
  USED_BY_HR_CONTACT = 'USED_BY_HR_CONTACT',
}

export enum EChannelType {
  SMS = 'SMS',
  RCS = 'RCS',
  TIME2CHAT = 'TIME2CHAT',
}

export type TChannelStatusDto = {
  id: number
  phone: string
  type: EChannelType
  provider: string
  settings: {
    regions: string[]
    useAsOneWayOverride: boolean
    displayedName?: string
  }
  ProjectId: number | null
  OrganizationId: number | null
  cordon: boolean
  status: EChannelStatusTag
  isInSubjectScope: boolean
  isPhoneCompatible: boolean
  conflictingHolder?: {
    type: TSubjectType
    id: number
    projectId: number
  }
}
